import { all } from "redux-saga/effects";

import projectSaga from "./project/sagas";
import layerTempStyleSaga from "./layerTempStyle/sagas";
import { saga as aclSaga } from "./acl";
import editFeatureSagas from "./editFeature/sagas";

export default function* rootSaga() {
  yield all([projectSaga(), layerTempStyleSaga(), aclSaga(), editFeatureSagas()]);
}
